import { useQuery } from 'react-query';
import { SrxApi } from '../api/SrxApi';

function useGetCurrentVersion() {
    const getCurrentVersion = async () => {
        const response = await SrxApi.get('/versions/latest-version');
        return response?.data;
    };
    const { data: currentVersion = null, isFetching: isCurrentVersionLoading } = useQuery(
        ['currentVersion'],
        getCurrentVersion,
        {
            staleTime: 1000 * 60 * 5,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            keepPreviousData: true,
        }
    );

    return { currentVersion, isCurrentVersionLoading };
}

export default useGetCurrentVersion;
